<script>
export default {
  name: 'UserProfileApp',
};
</script>

<template>
  <router-view />
</template>
